import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import DashboardNotificationBanner from '../DashboardNotificationBanner';
import { useUIStore } from '../../store/uiStore';

export default function Layout() {
  const isSidebarOpen = useUIStore(s => s.isSidebarOpen);
  const closeSidebar = useUIStore(s => s.closeSidebar);

  useEffect(() => {
    if (!isSidebarOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeSidebar();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isSidebarOpen, closeSidebar]);

  useEffect(() => {
    if (!isSidebarOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isSidebarOpen]);

  return (
    <div className="h-screen overflow-hidden bg-[#0a0a0a]">
      <div className="flex h-full">
        {/* Mobile / tablet drawer */}
        <div
          className={`fixed inset-0 z-40 lg:hidden ${
            isSidebarOpen ? 'pointer-events-auto' : 'pointer-events-none'
          }`}
          aria-hidden={!isSidebarOpen}
        >
          <div
            className={`fixed inset-0 bg-black/60 transition-opacity duration-300 ${
              isSidebarOpen ? 'opacity-100' : 'opacity-0'
            }`}
            onClick={closeSidebar}
          />
          <div
            className={`fixed inset-y-0 left-0 z-50 w-[min(100vw,16rem)] max-w-xs transform transition-transform duration-300 ease-out ${
              isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
            }`}
          >
            <Sidebar variant="drawer" />
          </div>
        </div>

        {/* Desktop sidebar */}
        <div className="sticky top-0 hidden h-screen shrink-0 lg:flex">
          <Sidebar variant="persistent" />
        </div>

        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <Header />
          <DashboardNotificationBanner />
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden bg-[#0a0a0a]">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}